import { render } from "./Suscripciones.vue?vue&type=template&id=24c3a0b2"
import script from "./Suscripciones.vue?vue&type=script&lang=js"
export * from "./Suscripciones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__